import React from 'react'
import PropTypes from "prop-types"
import styles from './Input.module.scss'

const Input = ({inputGroupText, inputRef, ...rest}) => (
    
    <input ref={inputRef} className={styles.input} {...rest} />
        
)

Input.propTypes = {
    inputGroupText: PropTypes.string,
    inputRef: PropTypes.object
}

export { Input }
